<template>
  <div class="space-between-y">
    <div class="both-sides">
      <div class="space-between-x">
        <input-item width="320" label="关键字搜索">
          <el-input v-model="filter.key" clearable placeholder="搜索模版名称/联系人/活动方"
                    @keyup.enter.native="search"/>
        </input-item>
        <input-item width="180" label="执行团队">
          <el-select v-model="filter.dealerId" clearable filterable placeholder="全部团队" @change="search">
            <el-option v-for="item in dealers" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </input-item>
        <input-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </input-item>
      </div>
      <el-button type="primary" icon="el-icon-plus" @click="createTemplate">新建流程模版</el-button>
    </div>

    <el-table v-loading="loading" :data="list" border stripe>
      <el-table-column prop="name" label="模版名称" min-width="180"/>
      <el-table-column prop="dealerName" label="执行团队" min-width="120">
        <template v-slot="scope">{{ scope.row.dealerName || '未指定' }}</template>
      </el-table-column>
      <el-table-column prop="host" label="活动方" min-width="130"/>
      <el-table-column prop="contact" label="联系人" min-width="100"/>
      <el-table-column prop="contactPhone" label="联系电话" min-width="130"/>
      <el-table-column prop="groupCount" label="流程数" width="80" align="center"/>
      <el-table-column prop="stepCount" label="步骤数" width="80" align="center"/>
      <el-table-column prop="eventTime" label="默认活动时间" min-width="170"/>
      <el-table-column fixed="right" label="操作" width="130" align="center">
        <template v-slot="scope">
          <el-button type="text" size="mini" @click="editTemplate(scope.row.id)">编辑</el-button>
          <el-button type="text" size="mini" class="danger-action" @click="deleteTemplate(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-model="page" @updated="fetchList"/>
  </div>
</template>

<script>
import InputItem from "@/components/base/layout/InputItem.vue";
import Pagination from "@/components/base/layout/Pagination.vue";
import {eventtype} from "@/api/eventtype";
import {user} from "@/api/user";

export default {
  name: "EventTypeList",
  components: {InputItem, Pagination},
  data() {
    return {
      filter: {key: "", dealerId: null},
      dealers: [],
      list: [],
      loading: false,
      page: {size: 10, current: 1, total: 0},
    };
  },
  created() {
    user.listAllDealer().then(res => { this.dealers = res.data || []; });
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.loading = true;
      return eventtype.list(this.page.size, this.page.current, this.filter.key, this.filter.dealerId)
          .then(res => {
            const data = res.data || {};
            this.list = data.list || [];
            this.page.total = data.total || 0;
          })
          .finally(() => { this.loading = false; });
    },
    search() {
      this.page.current = 1;
      this.fetchList();
    },
    reset() {
      this.filter = {key: "", dealerId: null};
      this.search();
    },
    createTemplate() {
      this.$router.push("/event-type/edit");
    },
    editTemplate(id) {
      this.$router.push({path: "/event-type/edit", query: {id}});
    },
    deleteTemplate(row) {
      this.$confirm(`确定删除流程模版「${row.name}」吗？`, "提示", {type: "warning"})
          .then(() => eventtype.delete(row.id))
          .then(() => {
            this.$message.success("删除成功");
            this.fetchList();
          })
          .catch(() => {});
    },
  },
};
</script>

<style scoped>
.danger-action { color: #f56c6c; }
</style>
